import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class AssetGeneratedFromColumn extends ProjectionGridBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'GeneratedFrom',
      property: 'RecommendationGeneratedFrom',
      title: i18n.getString('Details_View_Assets') || 'Assets',
      bodyClasses: ['grid-column-RecommendedFrom'],
      colClasses: ['col-mediumText'],
      sortable: 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.ResponsiveSearchAdsOpportunitySummary/HasAIAssetRecommendationCount',
      helpId: 'pop_MA_RSA_Recommendations',
      type: 'string',
      helpAriaLabel: i18n.getString(
        'Click to learn more about {{item}}',
        { item: i18n.getString('Details_View_Assets') }
      ),
    });

    this.i18n = i18n;
  }

  template({ value: { HasAIAssetRecommendationCount } }) {
    const { i18n } = this;
    return _.isNumber(HasAIAssetRecommendationCount) && HasAIAssetRecommendationCount > 0 ?
      i18n.getString('Recommendation_Keywword_Source_Type_AIGeneratedAssets') || 'AI-generated assets' :
      i18n.getString('Recommendation_Keywword_Source_Type_ExistingAssets') || 'Existing assets';
  }

  get property() {
    return {
      get: _.identity,
      key: 'RecommendationGeneratedFrom',
    };
  }
}
